import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faUsers,
  faQuestionCircle,
  faBars,
  faSignOutAlt,
  faStethoscope,
  faDollarSign,
  faMapMarkerAlt,
  faNewspaper,
  faCalendarCheck,
} from "@fortawesome/free-solid-svg-icons";

const AdminLayout = ({ children, onLogout, user }) => {
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 1024);
  const location = useLocation();

  const menuItems = [
    {
      path: "/admin/content",
      icon: faEdit,
      label: "Content Manager",
      description: "Editează textele site-ului",
    },
    {
      path: "/admin/bookings",
      icon: faCalendarCheck,
      label: "Programări",
      description: "Gestionează programările",
    },
    {
      path: "/admin/services",
      icon: faStethoscope,
      label: "Servicii",
      description: "Gestionează serviciile medicale",
    },
    {
      path: "/admin/team",
      icon: faUsers,
      label: "Echipa",
      description: "Membri echipei medicale",
    },
    {
      path: "/admin/locations",
      icon: faMapMarkerAlt,
      label: "Locații",
      description: "Locații cabinete medicale",
    },
    {
      path: "/admin/prices",
      icon: faDollarSign,
      label: "Prețuri",
      description: "Lista de prețuri",
    },
    {
      path: "/admin/articles",
      icon: faNewspaper,
      label: "Articole",
      description: "Gestionare articole blog",
    },
    {
      path: "/admin/faq",
      icon: faQuestionCircle,
      label: "FAQ",
      description: "Întrebări frecvente",
    },
    // ⚠️ COMMENTED OUT - Dangerous for production use
    // {
    //   path: "/admin/images",
    //   icon: faImages,
    //   label: "Media Library", 
    //   description: "Imagini și fișiere",
    // },
    // {
    //   path: "/admin/migration",
    //   icon: faDatabase,
    //   label: "Migration",
    //   description: "Populează tabele goale",
    // },
  ];

  const handleToggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
  };

  return (
    <div className="admin-layout">
      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Admin Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? "open" : "closed"}`}>
        <div className="sidebar-header">
          <div className="logo">
            <h3>Panou Administrator</h3>
          </div>
          <button
            className="sidebar-toggle"
            onClick={handleToggleSidebar}
            aria-label="Toggle sidebar"
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul className="nav-menu">
            {menuItems.map((item) => (
              <li key={item.path} className="nav-item">
                <Link
                  to={item.path}
                  className={`nav-link ${
                    location.pathname === item.path ? "active" : ""
                  }`}
                  data-tooltip={item.label}
                  onClick={() =>
                    window.innerWidth <= 1024 && setSidebarOpen(false)
                  }
                >
                  <FontAwesomeIcon icon={item.icon} className="nav-icon" />
                  {sidebarOpen && (
                    <div className="nav-content">
                      <span className="nav-label">{item.label}</span>
                      <small className="nav-description">
                        {item.description}
                      </small>
                    </div>
                  )}
                </Link>
              </li>
            ))}
          </ul>

          <div className="sidebar-footer">
            {sidebarOpen && user && (
              <div className="user-info">
                <div className="user-details">
                  <small className="user-email">{user.email}</small>
                  <small className="user-role">Administrator</small>
                </div>
              </div>
            )}
            <button
              className="logout-btn"
              onClick={handleLogout}
              aria-label="Logout"
              data-tooltip="Deconectare"
            >
              <FontAwesomeIcon icon={faSignOutAlt} className="nav-icon" />
              {sidebarOpen && <span>Deconectare</span>}
            </button>
          </div>
        </nav>
      </aside>

      {/* Main Content Area */}
      <main
        className={`admin-main ${
          sidebarOpen ? "sidebar-open" : "sidebar-closed"
        }`}
      >
        <div className="admin-content">{children}</div>
      </main>
    </div>
  );
};

export default AdminLayout;
